<template>
  <div class="boxHome">
    <common-header></common-header>
    <div style="height: 100%;padding-right: 3px;">
      <div class="boxMain"
           :style="boxMainStyle">
        <router-view></router-view>
      </div>
    </div>
    <common-footer></common-footer>
    <guide @guideStep="guideStep"
           v-if="visibleGuide"></guide>
  </div>
</template>

<script>
// 公共头部
import commonHeader from '../common/HeaderStyleA'
// 公共底部
import commonFooter from '../common/Footer'
// import GameList from '@/components/GameList'
import guide from '@/components/guide'
export default {
  name: 'home',
  data () {
    return {
      boxMainStyle: {
        height: document.body.clientHeight - 90 + 'px'
      },
      visibleGuide: false,
      adsTimer: false,
      isfirstInstall: true,
      adsTimerArr: [],
      token: '',
      openadsFlag: true,
      adsWidth: 0,
      adsheight: 0
    }
  },
  components: {
    commonHeader,
    commonFooter,
    guide
  },
  watch: {
    screenWidth (val) { }
  },
  mounted () {
    window.onresize = () => {
      this.boxMainStyle.height = document.body.clientHeight - 90 + 'px'
    }
    this.adsWidth = window.screen.width >= 1600 ? 420 : 380
    this.adsheight = window.screen.width >= 1600 ? 280 : 253
    // 首次安装
    this.Storage.get('launchTimes', res => {
      if (res.data.launchTimes && Number(res.data.launchTimes) && Number(this.fnClientInfo('gid')) < 0) {
        // alert(res.data.launchTimes)
        this.Storage.get('isfirstInstall', res => {
          if (res && Number(res.data.isfirstInstall)) {
            this.isfirstInstall = true
            this.visibleGuide = false
          } else {
            this.Storage.set('isfirstInstall', 1, r => { })
            this.isfirstInstall = true
            this.visibleGuide = false
          }
        })
        setTimeout(() => { this.getAdervertisement() }, 5000)
      } else {
        this.Storage.set('launchTimes', 1)
      }
    })
  },
  methods: {
    guideStep (type) {
      switch (type) {
        case 'close':
          this.isfirstInstall = true
          this.visibleGuide = false
          document.getElementsByClassName('boxMain')[0].scrollTop = 0
          break
        case 'stepone':
          document.getElementsByClassName('boxMain')[0].scrollTop = 0
          break
        case 'steptwo':
          document.getElementsByClassName('boxMain')[0].scrollTop = 660
          break
      }
    },
    getAdervertisement () {
      let t = this
      // 获取token
      t.Storage.get('USER', res => {
        if (res.data.USER) {
          t.token = res.data.USER.box_token
        }
      })
      t.XHR({
        url: t.ports.ads.rightAds,
        data: {
          token: t.token
        },
        cbFn (res) {
          if (res.status === 'error') {
            t.Toast({
              content: res.info
            })
            return false
          }
          t.showAdervertisement(res.data)
          t.adsTimer = setTimeout(() => {
            t.getAdervertisement()
          }, 10 * 60000)
        }
      })
    },
    showAdervertisement (data) {
      let t = this
      // 开机广告
      if (data.open && Object.keys(data.open).length > 0) {
        t.Storage.set('openAdsData', data.open, r => { })
        t.CEF.API('clientOpenWnd', {
          url: location.protocol + '//box.yilewan.com/#/Advertisement?type=open',
          status: 0,
          type: 0,
          syncookie: 1,
          width: window.screen.availWidth,
          height: window.screen.availHeight,
          center: false,
          top: window.screen.availHeight - t.adsheight,
          left: window.screen.availWidth - t.adsWidth,
          topmost: 0,
          window_name: data.open.title,
          window_title: data.open.title
        })
      }
      if (data.timer.length > 0) {
        t.Storage.set('timerAdsData', JSON.stringify(data.timer), r => { })
        data.timer.forEach((item, index, arr) => {
          t.countAds(item, index)
        })
      }
    },
    countAds (item, index) {
      let t = this
      let n = 0
      let timeDistance = item.show_time - item.current_time
      t.adsTimerArr[index] = setInterval(() => {
        n++
        if (n >= timeDistance) {
          clearInterval(t.adsTimerArr[index])
          t.CEF.API('clientOpenWnd', {
            url: location.protocol + '//box.yilewan.com/#/Advertisement?type=timer&index=' + index,
            status: 0,
            type: 0,
            syncookie: 1,
            width: window.screen.availWidth,
            height: window.screen.availHeight,
            center: false,
            top: window.screen.availHeight - t.adsheight,
            left: window.screen.availWidth - t.adsWidth,
            topmost: 0,
            window_name: item.title,
            window_title: item.title
          })
        }
      }, 1000)
    },
    fnClientInfo (k) {
      let wci = JSON.parse(window.clientInfo)
      if (wci[k]) {
        return wci[k]
      } else {
        return ''
      }
    }
  }
}
</script>
